import { useState, useEffect } from "react";
import { getBookingList } from "../../services/appointment.service";
import moment from "moment";
import NoRecordFound from "../../components/NoRecordFound";
import { useNavigate } from "react-router-dom";
function PanditJiScreen() {
  const navigate = useNavigate();
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);
  const [flattenedList, setFlattendList] = useState([]);
  const handleGetBookingList = async () => {
    setShowSkelton(true);
    try {
      let response = await getBookingList({ status: "kundaliAdded" });
      if (response?.data?.success) {
        setList(response?.data?.data);
        // Combine all kundaliDetails into a single array
        const flattenedList = response?.data?.data?.flatMap((value) =>
          value?.kundaliDetails?.map((v) => ({
            ...value,
            kundaliDetails: v, // Attach individual kundaliDetails to the parent object
          }))
        );
        let filteredArr = flattenedList?.filter((v, i) => {
          return v?.tokenNo == flattenedList[0].tokenNo;
        });
        setFlattendList(filteredArr);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList(); // Call immediately when screen loads

    const interval = setInterval(() => {
      handleGetBookingList();
    }, 5000); // Call every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  return (
    <div className="user-details-container">
      <div
        className="container d-flex align-items-center justify-content-between"
        style={{
          padding: "60px 0px",
          color: "#E1C699",
        }}
      >
        {/* Logo Section */}
        <div className="d-flex flex-column">
          <img
            src="/images/brandLogo.png"
            alt="Logo"
            className="d-inline-block align-text-top align-text-center img-fluid "
            style={{ objectFit: "contain", height: "150px", marginLeft: "-20px" }}
          />
        </div>

        {/* Title */}

        {/* Date and Time */}
        <div className="text-end">
          <p style={{ margin: 0, fontSize: "1.8rem", fontWeight: "500" }}>{moment().format("Do MMM YYYY")}</p>
          <p style={{ margin: 0, fontSize: "1.8rem", fontWeight: "500" }}> {moment().format("hh:mm A")}</p>
        </div>
      </div>

      {flattenedList?.map((v, i) => {
        return (
          <>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
              }}
            >
              <div className="text-center mb-0  align-items-end ">
                <span className="text-center mb-0 " style={{ fontSize: "1.5rem", fontWeight: "", color: "#C6A664" }}>
                  TOKEN NUMBER
                </span>
              </div>
              <h1 className="text-center mt-0" style={{ fontSize: "5rem", color: "#E1C699" }}>
                {flattenedList[0]?.tokenNo}
              </h1>
              <div className="container token-container d-flex flex-column">
                {/* First Card */}
                {flattenedList?.map((v, i) => {
                  return (
                    <div
                      onClick={() => navigate("/user-details/" + v?.kundaliDetails?._id)}
                      key={i}
                      className={
                        "token-card  text-center  " +
                        (i == 0 ? "token-card-light tokenShadow mb-5" : " yelloBorder token-card-dark")
                      }
                    >
                      <span className="px-1">{v?.kundaliDetails?.name}</span>
                      <span className="px-1">( Time : {v?.scheduledTime} )</span>
                    </div>
                  );
                })}

                {/* Second Card */}
                {/* <div className="token-card  text-center ">
            <span className="px-1">{userData[0].name}</span>
            <span className="px-1">( Time : {userData[0].time} )</span>
          </div> */}
              </div>
            </div>
            {list?.length == 0 && !showSkelton && (
              <div
                className="noRecordFoundMain d-flex justify-content-center align-items-center"
                style={{ background: "transparent", height: "50vh" }}
              >
                <div className="noRecordFoundInner text-light  ">
                  <h1>"This page is currently empty."</h1>
                  <p>
                    "It seems like there's no data to display here yet. As you manage and grow, this space will soon be
                    filled with valuable information."
                  </p>
                </div>
              </div>
            )}
          </>
        );
      })}
    </div>
  );
}

export default PanditJiScreen;
